import React, { useEffect, useState, useRef } from 'react';
import './Home.css'
import { useParams, useNavigate, useLocation } from 'react-router-dom';
//images
//objs
import Landing from './Landing';
import CommonButton, {btnColors, btnSizes} from '../../Objects/CommonButton/CommonButton';
import Title from '../../Objects/Title/Title';
import Loading, { loadingColors, loadingSpeeds } from '../../Objects/Loading/Loading';
import Input, { inputColors, inputSizes } from '../../Objects/Input/Input';
import Dialog from '../../Objects/Dialog/Dialog';
import FlatIcon from '../../Objects/Icona/FlatIcon';
import FullscreenIcon from '../../Objects/Icona/FullscreenIcon';
import { setValue, keyExists, addPathListener, addPresence, cancelPresence, removePath, timestamp, createRoom } from '../../firebase';
import { errcode, globalVars, scaleElements, fullScreen } from '../../App';
import LoadingDialog from '../../Objects/LoadingDialog/LoadingDialog';
import QRGenerator from '../../Objects/QRGenerator/QRGenerator';
import SettingsDialog from '../../Objects/SettingsDialog';
import GuideDialog from '../../Objects/GuideDialog';
import SEOHead from '../../components/SEOHead';
import SITE from '../../site';
import { applyPendingUpdate } from '../../serviceWorkerRegistration';


/*
    CRONOLOGIA DELLA HOME (stesso percorso, cambia solo lo stato della voce)
    nessun homeStep             -> 1: landing
    { homeStep: 2 }             -> 2: scelta del dispositivo
    { homeStep: 3, type: d|b }  -> 3: display (creazione stanza e QR, anche lo step 4) o pulsante (codice)
    Indietro/avanti del browser e il bottone «Indietro» della pagina passano tutti da qui.
*/
const readEntry = (location) => {
    const state = location.state || {};
    if(state.homeStep >= 3 && (state.type === "d" || state.type === "b")) {
        return { step: 3, type: state.type, key: location.key };
    }
    if(state.homeStep >= 2) {
        return { step: 2, type: null, key: location.key };
    }
    return { step: 1, type: null, key: location.key };
}

//codice partita nell'indirizzo (/:codice, dal QR)
const isGameCode = (code) => typeof code === "string" && code.trim() !== "" && code.length === 6;


const Home = ({settings, showSettings, guide, showGuide, options, upadting}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { paramCode } = useParams();

    //voce della cronologia con cui si apre la Home (ricarica della pagina o ritorno dalla partita)
    const [initial] = useState(() => readEntry(location));
    const [step, setStep] = useState(initial.step >= 2 ? 2 : 1);
    //landing: "static" al primo caricamento, "enter" tornando indietro, "leave" verso la scelta, null = smontata
    const [landingMode, setLandingMode] = useState(initial.step >= 2 ? null : "static");
    //entrata dei bottoni in basso: "in-late" arrivando dalla landing, "in" negli altri casi, "out" tornando alla landing
    const [bottomAnim, setBottomAnim] = useState("in");
    //tipo e codice mostrati negli step 3 e 4 (restano durante la dissolvenza in uscita)
    const [stepType, setStepType] = useState(null);
    const [roomCode, setRoomCode] = useState("");
    const [error, setError] = useState("");
    const [btnEnabled, setBtnEnabled] = useState(true);
    //join automatico dal QR in corso (solo se la Home si apre sulla landing)
    const [isParamValid, setParamValid] = useState(() => initial.step === 1 && isGameCode(paramCode));
    const [canConfirm, setCanConfirm] = useState(false);
    const canConfirmRef = useRef(canConfirm);

    //schermata logica: cambia subito, mentre "step" cambia dopo la dissolvenza
    const view = useRef({ step: initial.step >= 2 ? 2 : 1, type: null, key: initial.key });
    const stepRef = useRef(step);
    //sessione del display/pulsante: l'oggetto fa da token per le operazioni ancora in corso
    const session = useRef(null);
    const timers = useRef({ step: null, landing: null });
    const lateFade = useRef(false);
    //voce da cui è già partita una navigazione dei bottoni della pagina (evita i doppi click)
    const navLock = useRef(null);
    //ultima voce della cronologia gestita (null = nessuna: la Home si è appena aperta)
    const seenKey = useRef(null);
    //tornando dal display/pulsante alla scelta, il focus da tastiera va sul primo bottone (vedi fadeInStep)
    const focusChoice = useRef(false);
    const qrJoin = useRef(false);
    const mounted = useRef(false);

    const here = location.pathname + location.search;
    //la voce corrente non è più quella del display/pulsante: il bottone «Indietro» sta sparendo
    const leaving = readEntry(location).step < 3;

    //SE C'È UN AGGIORNAMENTO DELL'APP IN ATTESA, LO APPLICA (qui non c'è stato di gioco da perdere)
    useEffect(() => {
        applyPendingUpdate();
    }, []);

    useEffect(() => {
        mounted.current = true;
        const t = timers.current;       //sempre lo stesso oggetto, cambiano solo i suoi campi
        return () => {
            //uscendo dalla Home la sessione si chiude solo se non è diventata una partita
            mounted.current = false;
            clearTimeout(t.step);
            clearTimeout(t.landing);
            endSession(false);
        };
    }, []);

    //CONTROLLA SE ESISTE UN PARAMETRO E SE È UN CODICE PARTITA VALIDO
    //il join parte una sola volta (anche con StrictMode); upadting lo farebbe attendere, ma oggi App non lo attiva mai
    useEffect(() => {
        if(upadting || !isParamValid || qrJoin.current) {
            return;
        }
        qrJoin.current = true;
        const code = paramCode.toUpperCase();
        //Home chiusa prima delle scritture: il join si ferma senza occupare il posto
        //(con StrictMode il rimontaggio è immediato: quando arrivano le letture mounted è di nuovo true)
        const token = { get cancelled() { return !mounted.current; } };
        joinGame(code, token).then(() => {
            if(!mounted.current) {
                //la Home è stata chiusa durante le scritture: libera il posto del pulsante
                cancelPresence(code+"/button");
                removePath(code+"/button");
                return;
            }
            globalVars.code = code;
            globalVars.type = "b";
            //sostituisce la voce: indietro dalla partita non riporta al caricamento
            navigate("/game", { replace: true });
        }).catch((e) => {
            //console.log(e);
            if(mounted.current) {
                setParamValid(false);
            }
        })
    //paramCode e navigate non cambiano finché la Home è montata: il join deve partire una volta sola
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [upadting, isParamValid]);

    useEffect(() => {
        canConfirmRef.current = canConfirm;
    }, [canConfirm])

    useEffect(() => {
        scaleElements();
        showSettings(false);
        /* (async () => {
            await tsParticles.load({
              id: "tsparticles",
              options: {
                background: {
                  color: "#000"
                },
                particles: {
                  shape: {
                    type: "emoji",
                    options: {
                      emoji: {
                        value: ["🟨", "🟥", "🟧", "🟪", "🟦", "🟩"]
                      }
                    }
                  },
                  life: {
                    duration: {
                      value: 0
                    }
                  },
                  number: {
                    value: 200,
                    max: 0,
                    density: {
                      enable: true
                    }
                  },
                  move: {
                    gravity: {
                      enable: false
                    },
                    decay: 0,
                    direction: "bottom",
                    speed: 5,
                    outModes: "out"
                  },
                  size: {
                    value: 13
                  },
                  opacity: {
                    value: 1,
                    animation: {
                      enable: false
                    }
                  },
                  rotate: {
                    value: {
                      min: 0,
                      max: 360
                    },
                    direction: "random",
                    move: true,
                    animation: {
                      enable: true,
                      speed: 60
                    }
                  },
                  tilt: {
                    direction: "random",
                    enable: true,
                    move: true,
                    value: {
                      min: 0,
                      max: 360
                    },
                    animation: {
                      enable: true,
                      speed: 60
                    }
                  },
                  roll: {
                    darken: {
                      enable: true,
                      value: 30
                    },
                    enlighten: {
                      enable: true,
                      value: 30
                    },
                    enable: true,
                    mode: "both",
                    speed: {
                      min: 15,
                      max: 25
                    }
                  },
                  wobble: {
                    distance: 30,
                    enable: true,
                    move: true,
                    speed: {
                      min: -15,
                      max: 15
                    }
                  }
                },

                emitters: [],
                preset: "confetti"
              }
            });
          })(); */

        let iubendaFloat = document.querySelector(".iubenda-tp-btn");
        if(iubendaFloat) {
            iubendaFloat.style.pointerEvents = "auto"
            iubendaFloat.style.opacity = "1";
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //QUANDO CAMBIA LA VARIABILE STEP
    useEffect(() => {
        stepRef.current = step;
        if(step === 2) {
            //i bottoni della scelta sono div (CommonButton): così si raggiungono e si premono anche con la tastiera
            document.querySelectorAll(".home-step2 .common-btn").forEach((b) => {
                b.tabIndex = 0;
                b.setAttribute("role", "button");
            });
        }
        const t = setTimeout(() => {
            fadeInStep();
            scaleElements();
        }, 10);
        return () => clearTimeout(t);
    }, [step]);

    //QUANDO CAMBIA LA VOCE DELLA CRONOLOGIA (indietro/avanti del browser o del telefono, bottoni della pagina)
    useEffect(() => {
        //StrictMode ripete l'effetto sulla stessa voce al montaggio: conta solo la prima volta
        if(seenKey.current === location.key) {
            return;
        }
        const first = seenKey.current === null;
        seenKey.current = location.key;
        navLock.current = null;
        const target = readEntry(location);
        if(first && target.step >= 3) {
            //aperta su una voce di display/pulsante (pagina ricaricata): la sessione non esiste più.
            //La voce prima è sempre la scelta del dispositivo (le voci 3 nascono da lì): si torna su quella,
            //così il tasto indietro successivo porta alla landing. Tornando avanti su questa voce la schermata riparte
            const idx = window.history.state && window.history.state.idx;
            if(idx > 0) {
                navigate(-1);
            } else {
                navigate(here, { replace: true, state: { homeStep: 2 } });
            }
            return;
        }
        goTo(target);
    //solo il cambio di voce conta: goTo legge lo stato corrente dai ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);

    //QUANDO CAMBIA LA VARIABILE ERROR
    useEffect(() => {
        if(error !== "") {
            const t = setTimeout(() => {
                let d = document.querySelector("#error");
                if(d) {
                    d.style.opacity = null;
                    d.classList.add("fade-in");
                }
            }, 10);
            return () => clearTimeout(t);
        }
    }, [error])


    function fadeInStep() {         //FA COMPARIRE LA SCHERMATA CORRENTE
        //durante un cambio di schermata non fa ricomparire quella che sta uscendo
        if(timers.current.step) {
            return;
        }
        const el = document.querySelector(".home-step"+stepRef.current);
        if(!el) {
            return;
        }
        el.style.opacity = null;
        el.classList.remove("fade-out", "fade-in", "home-step-late");
        //arrivando dalla landing compare in ritardo, mentre lo studio si spegne
        el.classList.add(lateFade.current ? "home-step-late" : "fade-in");

        //tornando dal display/pulsante il focus non resta su <body> (né sul bottone «Indietro», ormai smontato):
        //va sul primo bottone della scelta. Dopo un click col mouse :focus-visible non mostra il contorno
        if(stepRef.current === 2 && focusChoice.current) {
            focusChoice.current = false;
            const active = document.activeElement;
            const first = el.querySelector(".common-btn");
            if(first && (!active || active === document.body || active.closest(".home-back"))) {
                first.focus({ preventScroll: true });
            }
        }
    }

    function showStep(next, { fade = true, late = false } = {}) {   //CAMBIA FASE DELLA SCHERMATA HOME
        clearTimeout(timers.current.step);
        timers.current.step = null;
        lateFade.current = late;

        const swap = () => {
            timers.current.step = null;
            if(next === stepRef.current) {
                //stessa schermata (cambio annullato a metà): React non la ridisegna, la fa ricomparire qui
                fadeInStep();
            } else {
                stepRef.current = next;
                setStep(next);
            }
        };

        if(!fade) {
            swap();
            return;
        }
        let cur = document.querySelector(".home-step"+stepRef.current);
        if(cur) {
            cur.classList.remove("fade-in", "home-step-late");
            cur.classList.add("fade-out");
        }
        timers.current.step = setTimeout(swap, 300);
    }

    //PORTA LA HOME ALLA SCHERMATA DELLA VOCE DI CRONOLOGIA
    function goTo(target) {
        const cur = view.current;
        view.current = target;
        if(cur.step === target.step && (target.step < 3 || (cur.type === target.type && cur.key === target.key))) {
            return;
        }
        //tornando alla landing nessuno spostamento del focus
        focusChoice.current = cur.step >= 3 && target.step === 2;

        //uscendo dalla schermata del display o del pulsante la sessione viene chiusa
        if(cur.step >= 3) {
            endSession(true);
        }

        if(target.step === 1) {
            //torna la landing: lo studio si accende sopra e la schermata sotto sparisce in fretta
            clearTimeout(timers.current.landing);
            timers.current.landing = null;
            setLandingMode("enter");
            setBottomAnim("out");
            showStep(1);
        } else if(cur.step === 1) {
            //dalla landing: lo studio si spegne e la schermata compare sotto, in ritardo
            setLandingMode("leave");
            clearTimeout(timers.current.landing);
            timers.current.landing = setTimeout(() => {
                timers.current.landing = null;
                setLandingMode(null);
            }, 1000);
            setBottomAnim("in-late");
            showStep(target.step, { fade: false, late: true });
        } else {
            showStep(target.step);
        }

        if(target.step === 3) {
            startSession(target.type);
        }
    }

    //NUOVA SESSIONE DOPO LA SCELTA DEL DISPOSITIVO (anche andando avanti nella cronologia)
    function startSession(type) {
        endSession(false);
        const s = { type, code: null, stop: null, joining: false, done: false, cancelled: false };
        session.current = s;
        globalVars.type = type;
        setStepType(type);
        if(type === "d") {
            createGame(s).catch((e) => {
                //errore imprevisto (es. Firebase): se il display è ancora su questa sessione lo vede nel popup
                console.error(e);
                if(session.current === s && !s.cancelled) {
                    setError(errcode["ERR_CREATE_GAME"]);
                }
            });
        } else {
            //la schermata del codice può essere ancora montata (indietro e avanti durante la dissolvenza):
            //«Entra» segue il codice rimasto nel campo
            const field = document.querySelector("#code");
            const input = field && field.querySelector(".input");
            if(field) {
                field.classList.remove(inputColors["error"]);
            }
            setCanConfirm(!!input && input.value.length === 6);
        }
    }

    //CHIUDE LA SESSIONE DEL DISPLAY O DEL PULSANTE (tornando indietro)
    function endSession(resetUi) {
        const s = session.current;
        if(!s) {
            return;
        }
        session.current = null;
        if(s.done) {
            //è diventata una partita: continua nel gioco
            return;
        }
        s.cancelled = true;
        if(typeof s.stop === "function") {
            s.stop();
        }
        if(s.code) {
            //stanza del display: annulla la rimozione automatica alla disconnessione e la rimuove subito
            cancelPresence(s.code);
            removePath(s.code);
        }
        globalVars.code = "";
        globalVars.type = "";
        if(resetUi) {
            setError("");
            setBtnEnabled(true);
            setCanConfirm(false);
        }
    }

    //CREAZIONE STANZA (display)
    //il codice è la chiave del nodo della stanza: la stanza si crea con una transazione (createRoom), che scrive
    //solo se il codice è libero, senza la finestra tra lettura e scrittura. Se è occupato si riprova con un altro.
    //Dopo ogni attesa controlla il token: se l'utente è tornato indietro non prosegue
    async function createGame(s) {
        //await new Promise((resolve) => setTimeout(resolve, 1000));
        const value = {
            "display": "online",
            "status": 0,
            "newRoom": true,
            //per riconoscere a mano le stanze inattive: lastAction si aggiorna a ogni scrittura (vedi firebase.js)
            "createdAt": timestamp(),
            "lastAction": timestamp(),
            "music": localStorage.getItem("music"),
            "effects": localStorage.getItem("effects")
        };
        let code = null;
        for(let i = 0; i < CREATE_ATTEMPTS && !code; i++) {
            const candidate = generateCode();
            if(await createRoom(candidate, value)) {
                code = candidate;
            }
            if(s.cancelled) {
                //l'utente è tornato indietro mentre la stanza veniva creata: se è nata, la rimuove
                if(code) {
                    removePath(code);
                }
                return;
            }
        }
        if(code) {
            //la stanza è nostra: solo ora si registra la rimozione alla disconnessione (mai sulla stanza di un altro).
            //Da qui endSession annulla la presenza e rimuove la stanza: le richieste arrivano al server in ordine
            s.code = code;
            globalVars.code = code;
            await addPresence(code);
            if(s.cancelled) {
                return;
            }
            //stanza creata
            //console.log("completato "+ code);
            setRoomCode(code);
            showStep(4);
            const stop = await addPathListener("button", (val) => {
                if(val === "online" && !s.cancelled && !s.done) {
                    //console.log("pulsante connesso DISPLAY");
                    s.done = true;
                    if(typeof s.stop === "function") {
                        s.stop();
                    }
                    //vai al gioco come display (prende il tipo da globalVars)
                    //sostituisce la voce: indietro dalla partita non riporta all'attesa
                    navigate("/game", { replace: true });
                }
            });
            s.stop = stop;
            if(s.cancelled || s.done) {
                stop();
            }
        } else {
            //nessun codice libero dopo vari tentativi (in pratica impossibile con 6 cifre)
            console.error("ERROR 3");
            setError(errcode["ERR_CREATE_GAME"]);
        }
    }

    const onInputChange = (event) => {
        if(event.target.value.length === 6) {
            setCanConfirm(true);
        } else {
            setCanConfirm(false);
        }
    }


    const play = () => {            //GIOCA ORA (dalla landing, dopo l'effetto del bottone)
        if(view.current.step !== 1 || navLock.current === location.key) {
            return;
        }
        navLock.current = location.key;
        navigate(here, { state: { homeStep: 2 } });
    }

    const choose = (type) => {      //DISPLAY ("d") / PULSANTE ("b")
        if(view.current.step !== 2 || navLock.current === location.key) {
            return;
        }
        navLock.current = location.key;
        navigate(here, { state: { homeStep: 3, type } });
    }

    const onChoiceKey = (event) => {    //INVIO O SPAZIO SU UN BOTTONE DELLA SCELTA (tastiera)
        if((event.key === "Enter" || event.key === " ") && event.target.classList.contains("common-btn")) {
            event.preventDefault();
            if(!event.repeat) {
                event.target.click();
            }
        }
    }

    const goBack = () => {          //BOTTONE «INDIETRO»: fa quello che fa il tasto indietro del browser
        if(navLock.current === location.key) {
            return;
        }
        navLock.current = location.key;
        if(location.state && location.state.homeStep >= 3) {
            //voce creata dalla scelta del dispositivo: quella prima è la scelta
            navigate(-1);
        } else {
            navigate(here, { replace: true, state: { homeStep: 2 } });
        }
    }

    const closePopup = () => {      //CHIUDE MESSAGGIO DI ERRORE
        let d = document.querySelector("#error");
        if(d) {
            d.classList.remove("fade-in")
            d.style.opacity = null;
            d.classList.add("fade-out");
        }
        setTimeout(() => {
            setError("");
            //display: la stanza non è stata creata, si torna alla scelta del dispositivo (come col tasto indietro)
            if(view.current.step >= 3 && view.current.type === "d") {
                goBack();
            }
        }, 100);
    }

    const checkCode = async () => { //CONTROLLA IL CODICE INSERITO E ENTRA IN PARTITA
        const s = session.current;
        if(!s || s.type !== "b" || s.joining) {
            return;
        }
        let code = document.querySelector("#code").querySelector(".input").value.toUpperCase();
        let input = document.querySelector("#code");
        input.classList.remove(inputColors["error"]);

        setBtnEnabled(false);

        if(code.trim() !== "" && code.length === 6) {
            s.joining = true;
            joinGame(code, s).then(() => {
                if(s.cancelled) {
                    //l'utente è tornato indietro durante le scritture: libera il posto del pulsante
                    cancelPresence(code+"/button");
                    removePath(code+"/button");
                    return;
                }
                //quando è entrato nel gioco
                //vai al gioco come bottone (prende il tipo da globalVars)
                //console.log("pulsante connesso BUTTON");
                s.done = true;
                globalVars.code = code;
                navigate("/game", { replace: true });
            }).catch((e) => {
                //console.log(e);
                if(s.cancelled) {
                    return;
                }
                s.joining = false;
                //errori senza codice (es. "1.2345": il punto non è valido in un percorso Firebase): la partita non esiste
                setError(errcode[e] || errcode["ERR_GAME_NOTFOUND"]);
                setBtnEnabled(true);
            })
        } else {
            input.classList.add(inputColors["error"]);
            setBtnEnabled(true);
        }

        }

    return (
        <>
            {/* SCHERMATA 1: LANDING (sopra la home, sotto i popup) */}
            {landingMode && <Landing
                mode={landingMode}
                connecting={isParamValid || !!upadting}
                onPlay={play}
                onGuide={() => showGuide(true)}
            />}

            <div className='home'>
                <SEOHead />

                {/* ERROR POPUP */}
                {error !== "" && <Dialog
                    id="error"
                    title="Si è verificato un errore!"
                    icon="warn"
                    plate="fire"
                    txt={error}
                    common={closePopup}
                />}

                <SettingsDialog
                    settings={settings}
                    showSettings={showSettings}
                    guide={guide}
                    showGuide={showGuide}
                    options={options}
                ></SettingsDialog>

                {<GuideDialog
                    guide={guide}
                    showGuide={showGuide}
                ></GuideDialog>}

                {/* LOADING DIALOG */}
                {!btnEnabled && <LoadingDialog id="loadingDialog"/>}


                {/* SCHERMATA 2 */}

                {step === 2 && <div className='home-step2' style={{opacity: 0}}>
                    <Title
                        txt="Come userai il dispositivo?"
                    />

                    <div className='step-body' onKeyDown={onChoiceKey}>
                        <CommonButton   //DISPLAY SELECT
                            id="display"
                            color={btnColors["orange"]}
                            txt="DISPLAY"
                            size={btnSizes["choice1"]}
                            click={() => choose("d")}
                        />
                        <CommonButton   //BUTTON SELECT
                            id="button"
                            color={btnColors["blue"]}
                            txt="PULSANTE"
                            size={btnSizes["choice2"]}
                            click={() => choose("b")}
                        />
                    </div>

                </div>}


                {/* STEP 3 DISPLAY */}

                {step === 3 && stepType === "d" && <div className='home-step3 step3-d' style={{opacity: 0}}>
                    <Loading id="loading" color={loadingColors["blue"]}/>
                </div>}
                {step === 3 && stepType === "d" && <div className='home-step2'></div>}


                {/* STEP 3 BUTTON */}
                {step === 3 && stepType === "b" && <div className='home-step3' style={{opacity: 0}}>
                    <Title
                        txt="Inserisci il codice della partita"
                    />

                    <div className='step-body'>
                        <Input
                            id="code"
                            size={inputSizes["default"]}
                            type="number"
                            color={inputColors["default"]}
                            placeholder="CODICE"
                            onChange={onInputChange}
                            confirm={() => {
                                if(canConfirmRef.current) {
                                    checkCode();
                                }
                            }}
                        />
                        <CommonButton   //DISPLAY SELECT
                            id="doneCode"
                            color={canConfirm ? btnColors["green"] : btnColors["grey"]}
                            txt="Entra"
                            size={btnSizes["default"]}
                            click={() => {
                                if(canConfirm) {
                                    checkCode()
                                }
                            }}
                            enabled={btnEnabled}
                        />
                    </div>



                </div>}


                {/* STEP 4 DISPLAY */}
                {step === 4 && stepType === "d" && <div className='home-step4' style={{opacity: 0}}>
                    <Title
                        txt="Partita creata!"
                    />

                    <div className='step-body'>
                        <div className='home-step4-d-1'>
                            <div className='home-step4-d-2'>
                                <QRGenerator data={SITE.url + roomCode} className={"display-qr"} />
                                <Input
                                    id="copyCode"
                                    size={inputSizes["done"]}
                                    color={inputColors["light-blue"]}
                                    value={roomCode}
                                    readOnly={true}
                                />
                            </div>
                            <div className='home-step4-d-2'>
                                <span id="display-instructions">
                                    Accedi alla partita dal tuo<br/>
                                    smartphone e crea le squadre<br/>
                                    per iniziare a giocare!
                                </span>
                                <div className='home-step4-d-3'>
                                    <Loading id="waiting-loading" color={loadingColors["grey"]} speed={loadingSpeeds["slow"]}/>
                                    <span id='display-waiting'>Attesa dispositivo...</span>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>}



                {/* BOTTONI SOTTO (non esistono sulla landing) */}
                {step >= 2 && <div className={'bottom bottom-'+bottomAnim}>
                    <CommonButton   //GUIDE BUTTON
                        id="guide"
                        color={btnColors["orange"]}
                        icon={<FlatIcon name="gear" size={55} weight={2.4}/>}
                        alt={"Icona impostazioni"}
                        size={btnSizes["mini"]}
                        click={() => {
                            showSettings(true);
                        }}
                    />
                    {step >= 3 && <button   //BACK BUTTON (torna alla scelta del dispositivo)
                        type="button"
                        className={'home-back' + (leaving ? ' home-back-out' : '')}
                        onClick={goBack}
                    >
                        <FlatIcon name="back" size={28} className='home-back-icon'/>
                        <span className='home-back-txt'>Indietro</span>
                    </button>}
                    <CommonButton   //FULLSCREEN BUTTON
                        id="fullscreen"
                        color={btnColors["blue"]}
                        icon={<FullscreenIcon/>}
                        alt={"Icona schermo intero"}
                        size={btnSizes["mini"]}
                        click={fullScreen}
                    />
                </div>}
            </div>
        </>
    );
}



//tentativi di creazione della stanza con codici diversi prima di arrendersi (vedi createGame)
const CREATE_ATTEMPTS = 5;

function generateCode() {
    //GENERA STRINGA RANDOM di 6 cifre (se il codice è occupato lo scopre la transazione di createRoom)
    let s="";
    for(let i=0;i<6;i++) {
      s += randomNumberSymbol();
    }

    return s;

    function randomNumberSymbol() {
      //const asciiCodeOfA = 65; // Codice ASCII per 'A'
      //const asciiCodeOfZ = 90; // Codice ASCII per 'Z'
      const ascii0 = 48; // Codice ASCII per '0'
      const ascii9 = 57; // Codice ASCII per '9'
      const randomAsciiCode = Math.floor(Math.random() * (ascii9 - ascii0 + 1)) + ascii0;
      return String.fromCharCode(randomAsciiCode);
    }
}

//token: sessione del pulsante (o join dal QR) che può essere annullata mentre il join è in corso.
//Se è annullata prima delle scritture il join si ferma senza scrivere nulla (rifiuta con "CANCELLED")
async function joinGame(code, token = null) {
    const cancelled = () => !!(token && token.cancelled);
    let exists = await keyExists(code);
    if(cancelled()) {
        return Promise.reject("CANCELLED");
    }

    if(exists) {
        //console.log("esiste");

        let exists = await keyExists(code+"/button") || !await keyExists(code+"/display");
        if(cancelled()) {
            return Promise.reject("CANCELLED");
        }
        if (exists) {
            //già in uso
            return Promise.reject("ERR_GAME_FULL");
        } else {
            //non in uso
            //la rimozione automatica si registra prima di occupare il posto: se la pagina si chiude o si ricarica
            //prima che il gioco registri la sua presenza, il posto non resta occupato
            await addPresence(code+"/button");
            await Promise.all([
                setValue(code+"/button", "online"),
                setValue(code+"/music", localStorage.getItem("music")),
                setValue(code+"/effects", localStorage.getItem("effects")),
            ])
            return Promise.resolve("partita in attesa di bottone");
        }
    } else {
        //console.log("non esiste");
        return Promise.reject("ERR_GAME_NOTFOUND");
    }
}

export default Home;
